import React,{useEffect,useState} from 'react'
import { Form, Input, Button } from 'antd';
import img from './../../asset/set.png'
import { config } from '../../service_psw';



export default function Step2(props) {
    const { port, next ,handlecamp} = props;
    const [showhand,setshow] = useState({emailVerify:null,smsVerify:null,wechatVerify:null}) 
    const handClick=(step,value)=>{
            handlecamp(step,value) 
    }
    useEffect(()=>{
        config().then((res)=>{
            console.log(res.data.emailVerify);
            console.log(res.data.smsVerify);
            console.log(res.data.wechatVerify);
            setshow({emailVerify:res.data.emailVerify,smsVerify:res.data.smsVerify,wechatVerify:res.data.wechatVerify})
        })
    },[])
    return (
        <div className='step1_dom'>
            <img style={{ marginBottom: '15px' }} src={img}></img>
            <div style={{ lineHeight: '22px' }}>请选择以下任一方式完成身份验证</div>
         {showhand.smsVerify?<Button onClick={()=>{handClick(3,1)}}>使用 短信验证码</Button> :null}
         {showhand.emailVerify?<Button onClick={()=>{handClick(3,2)}}>使用 邮箱验证码</Button>:null}
          {showhand.wechatVerify?<Button onClick={()=>{handClick(3,3)}}>使用 微信验证码</Button>:null}
         <Button onClick={()=>{handClick(3,4)}}>使用 密保问题验证</Button>
        </div>


    )
}

